
import React from "react";
import { Button } from "@/components/ui/button";

interface ProfileActionsProps {
  onChangePassword: () => void;
  onLogout: () => void;
}

export const ProfileActions: React.FC<ProfileActionsProps> = ({ 
  onChangePassword, 
  onLogout 
}) => {
  return (
    <div className="space-y-3 pb-4">
      <Button 
        variant="outline" 
        className="w-full"
        onClick={onChangePassword}
      >
        Changer mon mot de passe
      </Button>
      <Button 
        variant="outline" 
        className="w-full text-red-600 hover:text-red-700 hover:bg-red-50"
        onClick={onLogout}
      >
        Se déconnecter
      </Button>
    </div>
  );
};
